<template>
  <v-col>
    <v-row no-gutters>
      <v-col>
        <validation-provider
          :name="$t('integrations.fields.fulfillment_id')"
          :rules="{
            required: true,
            regex: /^[a-zA-Z0-9_-]+$/
          }"
          v-slot="{ errors }"
        >
          <v-text-field
            filled
            :label="$t('integrations.fields.fulfillment_id') + ' *'"
            v-model="attributes.fulfillment_id"
            :error-messages="errors"
            @input="updateAttributes"
          ></v-text-field>
        </validation-provider>
      </v-col>
    </v-row>
  </v-col>
</template>
<script>
export default {
  props: ["value"],
  data() {
    return {
      attributes: {}
    };
  },
  watch: {
    value: {
      deep: true,
      handler(newValue) {
        this.attributes = Object.assign({}, newValue);
      }
    }
  },
  methods: {
    updateAttributes() {
      this.$emit("input", this.attributes);
    }
  }
};
</script>
